/*jshint esversion: 6 */
// import store from '@/store/index';
import WorkPackageEditor from '@/router/components/WorkPackageEditor.component.js';
import WorkPackageImageZoom from '@/router/modules/WorkPackageImageZoom.module.js';

function Template(payload) {
  let route = WorkPackageEditor({
    path: payload.path,
    name: payload.name?payload.name:`${payload.location}WorkPackageEditor`,
    readonly: payload.readonly,
    location: payload.location,
    nav_back: payload.nav_back,
    children: [
      WorkPackageImageZoom(Object.assign(JSON.parse(JSON.stringify(payload)), {
        // location: payload.location,
        location: `${payload.location}WorkPackageEditor`,
        close: payload.name?payload.name:`${payload.location}WorkPackageEditor`
      }))
    ]
  });
  return route;
}
export default Template;
